import {
  Button,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  TextField,
  Typography,
} from "@material-ui/core";
import { DeleteOutlined, EditOutlined } from "@material-ui/icons";
import { getDatabase, ref, remove, update } from "firebase/database";
import React from "react";
import { useHistory } from "react-router-dom";
import { BeatLoader } from "react-spinners";
const User = ({ user, fetchUsers }) => {
  const [loading, setLoading] = React.useState(false);
  const [balance, setBalance] = React.useState(user?.balance);
  const [name, setName] = React.useState(user?.name);
  const [show, setShow] = React.useState(false);

  const history = useHistory();

  const deleteUser = async () => {
    if (window.confirm("Are you Want To Sure Delete This User")) {
      const db = getDatabase();
      remove(ref(db, `Users/${user.userId}`))
        .then((res) => {
          console.log("User Deleted Successful");
        })
        .catch((err) => {});
    } else {
    }
  };

  function updateUser(memberType) {
    const db = getDatabase();
    setLoading(true);
    update(ref(db, `Users/${user.userId}`), {
      name,
      balance: parseFloat(balance),
    })
      .then((res) => {
        setLoading(false);
        setShow(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }

  const goToSingleUserPage = () => {
    history.push("/user/" + user?.userId);
  };

  return (
    <div>
      <Card elevation={1}>
        <CardHeader
          //   avatar={<Person aria-label="recipe">R</Person>}
          action={
            <IconButton aria-label="settings">
              <DeleteOutlined onClick={() => deleteUser()} />
              <EditOutlined
                onClick={() => setShow(!show)}
                style={{ marginLeft: "10px" }}
              />
            </IconButton>
          }
          title={
            <div
              onClick={() => goToSingleUserPage()}
              style={{ cursor: "pointer" }}
            >
              {user.name}
            </div>
          }
          subheader={user.phone}
        />
        <CardContent>
          <Typography variant="h5" color="textSecondary">
            Balance: {user.balance}
          </Typography>
          <Typography variant="h6" color="textSecondary">
            Email: {user.email}
          </Typography>
          <Typography variant="h6" color="textSecondary">
            Refer Code :{" "}
            <span style={{ color: "green" }}>{user.myReferCode}</span>
          </Typography>
        </CardContent>

        {show && (
          <div style={{ marginLeft: "25px" }}>
            <TextField
              value={balance}
              onChange={(e) => setBalance(e.target.value)}
              label="Balance"
              variant="outlined"
              color="secondary"
              required
              type="number"
            />
            <br />
            <br />
            <br />
            <TextField
              value={name}
              onChange={(e) => setName(e.target.value)}
              label="Name"
              variant="outlined"
              color="secondary"
              required
              type="text"
            />
            <br />
            <br />
            {loading ? (
              <BeatLoader loading={loading} />
            ) : (
              <Button
                onClick={() => updateUser()}
                style={{ marginBottom: "10px" }}
                color="secondary"
                variant="outlined"
                type="submit"
                endIcon={<EditOutlined />}
              >
                Update
              </Button>
            )}
          </div>
        )}
      </Card>
    </div>
  );
};

export default User;
